import { render, staticRenderFns } from "./Turnstiles.vue?vue&type=template&id=a700d9f4&scoped=true"
import script from "./Turnstiles.vue?vue&type=script&lang=js"
export * from "./Turnstiles.vue?vue&type=script&lang=js"
import style0 from "./Turnstiles.vue?vue&type=style&index=0&id=a700d9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a700d9f4",
  null
  
)

export default component.exports